import { useState, useEffect } from "react";
import { ShoppingBag, Menu, X } from "lucide-react";

const Logo = ({ className = "" }) => (
  <div className={`flex items-center ${className}`}>
    <img src="/ttw-logo.png" alt="TTW Engineering" className="h-10 w-auto" />
  </div>
);

export { Logo };

export default function Navigation({ onShopClick, showShop }) {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    if (showShop) {
      onShopClick(false);
      setTimeout(() => {
        document.getElementById(sectionId)?.scrollIntoView({ behavior: "smooth" });
      }, 100);
    } else {
      document.getElementById(sectionId)?.scrollIntoView({ behavior: "smooth" });
    }
  };

  const navLinks = [
    { href: "#home", label: "Home", action: () => { if (showShop) onShopClick(false); else window.scrollTo({ top: 0, behavior: "smooth" }); } },
    { href: "#services", label: "Services", action: () => scrollToSection("services") },
    { href: "#power-gains", label: "Power Gains", action: () => scrollToSection("power-gains") },
    { href: "#shop", label: "Shop", action: () => onShopClick(true) },
    { href: "#contact", label: "Contact", action: () => scrollToSection("contact") },
  ];

  return (
    <nav
      data-testid="main-navigation"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-[#0A0A0A]/95 backdrop-blur-md shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <a href="#home" data-testid="logo-link"><Logo /></a>
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href="#"
                onClick={(e) => { e.preventDefault(); link.action(); }}
                data-testid={`nav-${link.label.toLowerCase().replace(' ', '-')}`}
                className={`nav-link font-medium text-sm uppercase tracking-wider cursor-pointer ${
                  link.label === 'Shop' ? 'text-[#FF3B30] hover:text-[#FF6B30]' : 'text-[#B0B0B0] hover:text-white'
                }`}
              >
                {link.label === 'Shop' && <ShoppingBag size={14} className="inline mr-1 -mt-0.5" />}
                {link.label}
              </a>
            ))}
          </div>
          <button data-testid="mobile-menu-button" className="md:hidden text-white" onClick={() => setIsOpen(!isOpen)}>
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>
      {isOpen && (
        <div data-testid="mobile-menu" className="md:hidden bg-[#111111] border-t border-[#2A2A2A]">
          <div className="px-4 py-4 space-y-3">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href="#"
                onClick={(e) => { e.preventDefault(); link.action(); setIsOpen(false); }}
                data-testid={`mobile-nav-${link.label.toLowerCase().replace(' ', '-')}`}
                className={`block font-medium py-2 uppercase tracking-wider cursor-pointer ${
                  link.label === 'Shop' ? 'text-[#FF3B30] hover:text-[#FF6B30]' : 'text-[#B0B0B0] hover:text-white'
                }`}
              >
                {link.label === 'Shop' && <ShoppingBag size={14} className="inline mr-1 -mt-0.5" />}
                {link.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
}
